<template>
    <div>
      <video ref="video" width="100%" height="100%"></video>
      <button @click="startScan">Start Scanning</button>
      <div v-if="barcodeData">Barcode detected: {{ barcodeData }}</div>
    </div>
  </template>

<script>
import { BrowserMultiFormatReader } from '@zxing/library'

export default {
  data () {
    return {
      codeReader: null,
      barcodeData: null
    }
  },
  methods: {
    startScan () {
      this.codeReader = new BrowserMultiFormatReader()
      this.codeReader.decodeFromVideoDevice(null, this.$refs.video, (result, err) => {
        if (result) {
          this.barcodeData = result.getText()
          console.log('Barcode detected:', result.getText())
          this.codeReader.reset() // Камер зогсоох
        }
        if (err) {
          console.error('Error:', err)
        }
      })
    }
  },
  beforeDestroy () {
    if (this.codeReader) {
      this.codeReader.reset()
    }
  }
}
</script>
